import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { ReleaseGroupsForProject } from '../../../../shared/types/routes/projects';

function fetchReleaseGroups(projectLocator: string) {
  return get<{releaseGroups: ReleaseGroupsForProject[]}>(`/api/v2/projects/${nuc(projectLocator)}/release-groups`, false);
}

const getQueryKey = (locator: string): QueryKey => ['projects', locator, 'release-groups'];

/**
 * Query for the release groups of a project.
 *
 * @param {string} projectLocator - The projectLocator of the project whose branches to fetch. No need to call nuc before passing it in here.
 * @param {boolean} shouldFetch - Will not fetch if false.
 */
export default function useProjectReleaseGroups(projectLocator: string, shouldFetch = true) {
  return useQuery({
    queryKey: getQueryKey(projectLocator),
    queryFn: () => fetchReleaseGroups(projectLocator),
    enabled: shouldFetch,
  });
}
